import React from 'react';

const TravelPreferencesTab = ({ formData, handleNestedInputChange, FormField }) => {
  return (
    <div className="bg-white/95 backdrop-blur-xl border border-white/20 shadow-2xl shadow-slate-200/50 rounded-3xl p-8 overflow-hidden relative">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-violet-50/40 via-transparent to-purple-50/40 pointer-events-none" />

      {/* Header */}
      <div className="relative flex items-center gap-4 mb-8">
        <div className="w-14 h-14 bg-gradient-to-br from-violet-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg shadow-violet-500/30">
          <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
        </div>
        <div>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">Travel Preferences</h2>
          <p className="text-slate-500 mt-1">Preferred airlines, hotels, and travel arrangements</p>
        </div>
      </div>

      <div className="relative space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          <FormField
            id="preferred_airline"
            label="Preferred Airline"
            value={formData.travel_preferences?.preferred_airline || ''}
            onChange={(e) => handleNestedInputChange('travel_preferences', 'preferred_airline', e.target.value)}
            placeholder="e.g., American Airlines, United"
          />
          
          <FormField
            id="seat_preference"
            label="Seat Preference"
            value={formData.travel_preferences?.seat_preference || ''}
            onChange={(e) => handleNestedInputChange('travel_preferences', 'seat_preference', e.target.value)}
            placeholder="e.g., Aisle, Window, Business Class"
          />
          
          <FormField
            id="hotel_chain_preference"
            label="Hotel Chain Preference"
            value={formData.travel_preferences?.hotel_chain_preference || ''}
            onChange={(e) => handleNestedInputChange('travel_preferences', 'hotel_chain_preference', e.target.value)}
            placeholder="e.g., Marriott, Hilton, Hyatt"
          />
          
          <FormField
            id="room_type_preference"
            label="Room Type Preference"
            value={formData.travel_preferences?.room_type_preference || ''}
            onChange={(e) => handleNestedInputChange('travel_preferences', 'room_type_preference', e.target.value)}
            placeholder="e.g., Suite, King Room, Executive Floor"
          />
          
          <FormField
            id="car_rental_preference"
            label="Car Rental Preference"
            value={formData.travel_preferences?.car_rental_preference || ''}
            onChange={(e) => handleNestedInputChange('travel_preferences', 'car_rental_preference', e.target.value)}
            placeholder="e.g., Hertz, Avis, Enterprise"
          />
          
          <FormField
            id="dietary_restrictions"
            label="Dietary Restrictions"
            value={formData.travel_preferences?.dietary_restrictions || ''}
            onChange={(e) => handleNestedInputChange('travel_preferences', 'dietary_restrictions', e.target.value)}
            placeholder="e.g., Vegetarian, Gluten-free, None"
          />
        </div>
        
        <div className="space-y-2">
          <label htmlFor="special_requests" className="text-sm font-semibold text-slate-700">Special Requests</label>
          <textarea
            id="special_requests"
            value={formData.travel_preferences?.special_requests || ''}
            onChange={(e) => handleNestedInputChange('travel_preferences', 'special_requests', e.target.value)}
            className="w-full h-28 px-4 py-3 bg-white border border-slate-200 rounded-xl resize-none
              focus:border-violet-400 focus:ring-4 focus:ring-violet-100 focus:shadow-lg focus:shadow-violet-100/50
              hover:border-slate-300 hover:shadow-sm
              transition-all duration-200 ease-out placeholder:text-slate-400"
            placeholder="Any special accommodations, accessibility needs, or requests"
          />
        </div>
      </div>
    </div>
  );
};

export default TravelPreferencesTab;